"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShopIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const ShopIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props, { viewBox: "0 0 24 24", width: "24", height: "24" }),
    react_1.default.createElement("path", { d: "M5.1849 5.22265C5.27763 5.08355 5.43375 5 5.60093 5H18.3991C18.5663 5 18.7224 5.08355 18.8151 5.22265L21.4818 9.22265C21.7033 9.55493 21.4651 10 21.0657 10H2.93426C2.53491 10 2.29672 9.55493 2.51823 9.22265L5.1849 5.22265Z" }),
    react_1.default.createElement("path", { d: "M18 11H20V18.5C20 18.7761 19.7761 19 19.5 19H18.5C18.2239 19 18 18.7761 18 18.5V11Z" }),
    react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 11H4V18.5C4 18.7761 4.22386 19 4.5 19H12.5C12.7761 19 13 18.7761 13 18.5V11H11V16H6V11Z" })));
exports.ShopIcon = ShopIcon;
exports.default = exports.ShopIcon;
